import { IMG } from "@/data/content";

export default function PlantMap() {
  return <figure className="overflow-hidden rounded-2xl border border-black/10 bg-white shadow-sm">
    <img src={IMG.asphaltMap} alt="Florida supply locations: Winter Garden, Ft. Pierce, West Palm Beach, and Miami" className="w-full h-auto" loading="lazy" />
    <figcaption className="px-5 py-4 text-sm text-rc-brown">Asphalt supply across Central and South Florida. Contact dispatch to coordinate pickup.</figcaption>
  </figure>;
}
